import z from 'zod'
import { nullSafeString, nullSafeStringArray } from '../shared/schema'

export const schema = z.object({
  title: nullSafeString(''),
  description: nullSafeString(''),
  requiredPrompts: nullSafeStringArray([]),
  optionalPrompts: nullSafeStringArray([]),
  requiredFields: nullSafeStringArray([]),
  promptType: z.literal('interactive_element_prompt'),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: 'interactive_element_prompt',
  })
)

export type FirestorePromptInteractiveElementType = z.infer<typeof schema>
